module.exports = __webpack_public_path__ + "media/assets/service_ruby-57b9f9752567ea6af14afdd5d8befd2e.svg";